module.exports = __webpack_public_path__ + "d7b3ede1e18ade29f29ab39f98136421.svg";